var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "wrap" },
      [
        _c("Toolbar", {
          staticClass: "toolbar",
          attrs: { editor: _vm.editor, defaultConfig: _vm.toolbarConfig },
        }),
        _c("Editor", {
          ref: "editor",
          staticClass: "editor",
          attrs: { defaultConfig: _vm.editorConfig },
          on: { onChange: _vm.onChange, onCreated: _vm.onCreated },
          model: {
            value: _vm.html,
            callback: function ($$v) {
              _vm.html = $$v
            },
            expression: "html",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }